import React, { useState } from 'react'
import '../modal.css'
import PhoneComponents from './Auth/PhoneComponents';
import OTPComponents from './Auth/OTPComponents';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Toastify from 'toastify-js'
import { Image } from 'react-bootstrap';
import { pushEvent, EVENTS } from '../utils/dataLayer';

const isMainDomain = () => {
  const hostname = window.location.hostname;
  const mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info';
  return hostname === mainDomain || process.env.REACT_APP_DOMAIN === 'main';
};

const MAIN_DOMAIN_URL = process.env.REACT_APP_MAIN_DOMAIN_URL || `https://${process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info'}/`;
const LOGIN_DOMAIN_URL = process.env.REACT_APP_LOGIN_DOMAIN_URL || `https://${process.env.REACT_APP_LOGIN_DOMAIN || 'login.dastaan.info'}/`;

const showToast = (msg) => {
  Toastify({
    text: msg,
    duration: 3000,
    newWindow: true,
    close: true,
    gravity: 'bottom',
    position: 'center',
    stopOnFocus: true,
    style: { background: 'linear-gradient(to right, #000000ff, #000000ff)' },
    onClick: function () {}
  }).showToast();
};

const Modal = ({ show, onClose, hideCloseButton = false, initialPhone = '', initialStep = 'phone' }) => {
  const [phone, setPhone] = useState(initialPhone);
  const [otp, setOtp] = useState('');
  const [showOTP, setShowOTP] = useState(initialStep === 'otp' && !!initialPhone);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const path_name = window.location.pathname;
  const segments = path_name.split('/');
  const fromMainDomain = isMainDomain();
  const navigate = useNavigate();
  const handleContinue = () => {
    if (isSubmitting) return;
    if (showOTP) {
      verifyOtp();
    } else {
      sendOTP();
    }
  };

  const checkUtmSource = async (phoneNumber) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/check-utm-source`, { phone: phoneNumber });
      const { source_available, subscribed } = response.data;
      if (source_available === true && subscribed === false) {
        window.location.href = `${LOGIN_DOMAIN_URL}login?phone=${encodeURIComponent(phoneNumber)}&step=otp`;
      }
    } catch (e) {
      // silent fail — don't disrupt login flow
    }
  };

  const sendOTP = async () => {
    setIsSubmitting(true);
    if (fromMainDomain) checkUtmSource(phone); // fire in parallel, no await
    const utmData = JSON.parse(localStorage.getItem("utmData")) || {};
    const data = {
      phone,
      utm_source: utmData.utm_source || "",
      utm_medium: utmData.utm_medium || "",
      utm_campaign: utmData.utm_campaign || "",
      click_id: utmData.click_id || ""
    };
    await axios.post(`${process.env.REACT_APP_API_URL}/send-otp`, data)
      .then((response) => {
        const res = response.data;
        const resItem = res.Podcast_App[0];
        const { msg, success } = resItem;
        if (success === "1") {
          pushEvent(EVENTS.OTP_REQUEST, { utm_source: data.utm_source, utm_campaign: data.utm_campaign });
          if (fromMainDomain) {
            const tagged = resItem.is_tagged === true || resItem.is_tagged === 1 || resItem.is_tagged === '1';
            const subscribed = resItem.is_subscribed === true || resItem.is_subscribed === 1 || resItem.is_subscribed === '1';
            if (tagged && subscribed) {
              // Auto-login: store user data if provided and redirect to main domain
              if (resItem.token) {
                localStorage.setItem("dastaan__token", resItem.token);
                localStorage.setItem("dastaan__user_id", resItem.user_id || '');
                localStorage.setItem("dastaan__phone", phone);
                localStorage.setItem("dastaan__name", resItem.name || '');
                localStorage.setItem("dastaan__user_image", resItem.user_image || '');
                localStorage.setItem("dastaan__plan_id", resItem.plan_id || '');
                localStorage.setItem("dastaan__plan_amnt", resItem.plan_amount || '');
              }
              window.location.href = MAIN_DOMAIN_URL;
              return;
            } else if (tagged && !subscribed) {
              // Has account but no subscription — redirect to login domain /login for OTP + plans
              // /login route reads initialPhone and initialStep from URL params
              window.location.href = `${LOGIN_DOMAIN_URL}login?phone=${encodeURIComponent(phone)}&step=otp`;
              return;
            }
            // Not tagged — fall through and proceed with OTP
          }
          showToast(msg);
          setShowOTP(true);
        }
        setIsSubmitting(false);
      })
      .catch((error) => {
        const status = error?.response?.status;
        const msg = status >= 500
          ? 'Server error. Please try again in a moment.'
          : status === 0 || !status
          ? 'No internet connection. Please check your network.'
          : error?.response?.data?.message || 'Something went wrong. Please try again.';
        showToast(msg);
        setIsSubmitting(false);
      });
  };
  const verifyOtp = () => {
    setIsSubmitting(true);
    const data = { phone, otp };
    axios.post(`${process.env.REACT_APP_API_URL}/verify-otp`, data)
      .then((response) => {
        const resData = response.data.Podcast_App;
        const user_image = resData[0].user_image;
        const name = resData[0]?.name;
        const token = resData[0]?.token;
        const verifiedPhone = resData[0]?.phone;
        const user_id = resData[0]?.user_id;
        const exp_date = resData[0]?.user_profiles[0]?.exp_date;
        const plan_id = resData[0]?.user_profiles[0]?.plan_id;
        const plan_amnt = resData[0]?.user_profiles[0]?.plan_amount;
        localStorage.setItem("dastaan__user_image", user_image);
        localStorage.setItem("dastaan__name", name);
        localStorage.setItem("dastaan__user_id", user_id);
        localStorage.setItem("dastaan__phone", verifiedPhone);
        localStorage.setItem("dastaan__token", token);
        localStorage.setItem("dastaan__plan_id", plan_id);
        localStorage.setItem("dastaan__plan_amnt", plan_amnt);
        // Pushed after storing auth so the event carries the new user_id.
        pushEvent(EVENTS.LOGIN, { method: 'otp', has_plan: plan_id != null, plan_amount: plan_amnt ?? null });
        showToast(resData[0].msg);
        if (plan_id == null) {
          navigate('/plans');
        } else {
          if (segments[1] === '') {
            window.location.reload();
          } else {
            navigate('/');
          }
        }
      })
      .catch((error) => {
        const status = error?.response?.status;
        const msg = status >= 500
          ? 'Server error. Please try again in a moment.'
          : status === 0 || !status
          ? 'No internet connection. Please check your network.'
          : error?.response?.data?.message || 'Something went wrong. Please try again.';
        pushEvent(EVENTS.LOGIN_FAILED, { method: 'otp', error_status: status || null });
        showToast(msg);
        setIsSubmitting(false);
      });
  };
  if (!show) return null;
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
       zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center'
    }}>
      <div className='modal-css'>
        {/* Modal header row: close button */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: '32px',
          marginBottom: '4px',
        }}>
          {!hideCloseButton && (
            <div style={{ cursor: 'pointer' }} onClick={() => { onClose(); setPhone(''); setShowOTP(false); }}>
              <Image
                className='close-btn'
                src={`${process.env.PUBLIC_URL}/player_icons/close_player.svg`}
              />
            </div>
          )}
        </div>
        {showOTP === true
          ? <OTPComponents phone={phone} otp={otp} setOtp={setOtp} onContinue={handleContinue} disabled={isSubmitting} />
          : <PhoneComponents phone={phone} setPhone={setPhone} onContinue={handleContinue} disabled={isSubmitting} />
        }
      </div>
    </div>
  );
}
export default Modal
